export default "__VITE_ASSET__b7lQ6YHq__"